export const fetchPriceBreakup = async (
  slug: string,
  cityId: number
): Promise<any> => {
  const queryParams = new URLSearchParams({
    slug,
    city_id: cityId.toString(),
  });

  const url = `/api/price-breakup/?${queryParams.toString()}`;
  const response = await fetch(url);

  if (!response.ok) {
    let errorMessage = `API Error ${response.status}: ${url}`;
    try {
      const errorData = await response.json();
      errorMessage = errorData.error || errorMessage;
    } catch {
      // If response is not JSON, use status text
      errorMessage = `${errorMessage} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
};